import React, { useCallback } from 'react';
import { SearchMenuBar, SearchMenuColumn, type SearchMenuItem } from '../../../../search-menu';
import type { SelectedProxy } from '../types';

const isOptionHasHoldingsData = (option: SearchMenuItem) => {
  return (
    option.value?.fund?.investmentSource === 'VENN' &&
    ['MUTUAL_FUND', 'STOCK', 'ETF'].includes(option.value?.fund?.assetType)
  );
};

const HoldingsProxySearch = ({
  disabled = false,
  selectedProxy,
  setSelectedProxy,
}: {
  disabled?: boolean;
  selectedProxy: SelectedProxy | null;
  setSelectedProxy: (proxy: SelectedProxy) => void;
}) => {
  const onSelected = useCallback(
    (selected: SearchMenuItem) => {
      if (!selected.value?.fund) {
        return;
      }
      setSelectedProxy({ name: selected.label, id: selected.value.fund.id });
    },
    [setSelectedProxy],
  );

  return (
    <SearchMenuBar
      onSelected={onSelected}
      displayResultsAsBlock={!disabled}
      investmentsOnly
      autofocus={false}
      proxyable
      isClearable
      clearQueryOnBlur
      privateAssetSearchMode="PUBLIC_ONLY"
      location="bulk-proxy-picker"
      shortPlaceholder
      columns={[SearchMenuColumn.CCY, SearchMenuColumn.IDENTIFIER, SearchMenuColumn.TYPE]}
      placeholders={selectedProxy ? { ids: [{ id: selectedProxy.id, type: 'FUND' }], type: 'investment' } : undefined}
      isOptionDisabled={(item) => !isOptionHasHoldingsData(item)}
      maxResults={14}
      smallScreen
      refreshedStyling
      forceShowSearchIcon
      menuStyles={{ backgroundColor: 'transparent' }}
      showRecentlyAnalyzed={false}
    />
  );
};

export default HoldingsProxySearch;
